export type CodeTabID = 'experiment1' | 'experiment2' | 'split' | 'unified';
export const COMPARE_TAB: Record<string, CodeTabID> = {
  EXPERIMENT_1: 'experiment1',
  EXPERIMENT_2: 'experiment2',
  SPLIT: 'split',
  UNIFIED: 'unified'
};
